import { AddProductToMyWishlistInput } from '@spa/generated/graphql/graphql';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiAddProductToMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly input: AddProductToMyWishlistInput;
  readonly parentActionId: number;
}

export const apiAddProductToMyWishlistRequestedType =
  'api/wishlist/addProductToMyWishlist--requested';
export const apiAddProductToMyWishlistRequested =
  createAction<ApiAddProductToMyWishlistRequestedPayload>(apiAddProductToMyWishlistRequestedType);
export type ApiAddProductToMyWishlistRequestedAction = ReturnType<
  typeof apiAddProductToMyWishlistRequested
>;

export interface ApiAddProductToMyWishlistSucceededPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly result: ReadonlyArray<StateWishlist>;
}

export const apiAddProductToMyWishlistSucceededType =
  'api/wishlist/addProductToMyWishlist--succeeded';
export const apiAddProductToMyWishlistSucceeded = createAction<
  ApiAddProductToMyWishlistSucceededPayload,
  typeof apiAddProductToMyWishlistSucceededType
>(apiAddProductToMyWishlistSucceededType);
export type ApiAddProductToMyWishlistSucceededAction = ReturnType<
  typeof apiAddProductToMyWishlistSucceeded
>;

export interface ApiAddProductToMyWishlistFailedPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly error: WishlistError;
}

export const apiAddProductToMyWishlistFailedType = 'api/wishlist/addProductToMyWishlist--failed';
export const apiAddProductToMyWishlistFailed = createAction<
  ApiAddProductToMyWishlistFailedPayload,
  typeof apiAddProductToMyWishlistFailedType
>(apiAddProductToMyWishlistFailedType);
export type ApiAddProductToMyWishlistFailedAction = ReturnType<
  typeof apiAddProductToMyWishlistFailed
>;
